<template>
  <el-card>
    <div class="penguan-content">
      <div class="left">
        <el-form :model="info" ref="info" :rules="rules" label-width="100px" class="global-form2">
          <el-collapse class="mb20" :value="['areaInfo', 'deviceInfo']">
            <el-collapse-item title="喷灌区域" name="areaInfo">
              <el-form-item label="区域名称" prop="areaName">
                <el-input v-model="info.areaName" placeholder="请输入区域名称"></el-input>
              </el-form-item>
              <el-form-item label="面积（㎡）" prop="areaExtent">
                <el-input v-model="info.areaExtent" placeholder="请输入区域面积"></el-input>
              </el-form-item>
            </el-collapse-item>
            <el-collapse-item title="设备选择" name="deviceInfo">
              <el-form-item label="电磁阀" prop="valveList">
                <el-select v-model="info.valveList" filterable clearable multiple placeholder="请选择电磁阀" @change="drawMarkers">
                  <el-option :label="getBindName(item)" :value="item.deviceNumber" v-for="(item, index) in valveList"
                    :key='index'>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="土壤温湿" prop="soilList">
                <el-select v-model="info.soilList" filterable clearable multiple placeholder="请选择土壤温湿传感器" @change="drawMarkers">
                  <el-option :label="getBindName(item)" :value="item.deviceNumber" v-for="(item, index) in soilList"
                    :key='index'>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="智慧水表" prop="waterList">
                <el-select v-model="info.waterList" filterable clearable multiple placeholder="请选择智慧水表" @change="drawMarkers">
                  <el-option :label="getBindName(item)" :value="item.deviceNumber" v-for="(item, index) in waterList"
                    :key='index'>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="智慧电表" prop="electricityList">
                <el-select v-model="info.electricityList" filterable clearable multiple @change="drawMarkers" placeholder="请选择智慧电表">
                  <el-option :label="getBindName(item)" :value="item.deviceNumber"
                    v-for="(item, index) in electricityList" :key='index'>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="流压监测" prop="waterLyList">
                <el-select v-model="info.waterLyList" filterable clearable multiple @change="drawMarkers" placeholder="请选择流压监测">
                  <el-option :label="getBindName(item)" :value="item.deviceNumber"
                    v-for="(item, index) in waterLyList" :key='index'>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-collapse-item>
          </el-collapse>
          <el-form-item>
            <el-button type="primary" @click="onSubmit" :disabled="submitShow">保存</el-button>
            <el-button @click="$router.go(-1)">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="right">
        <div class="map">
          <div class='rangeMapOperation'>
            <el-button-group>
              <el-button :class="[{ 'isActive': status === 'choose' }]" type="primary" @click="choosePolyon">
                <span class="iconfont icon-tuodong global-icon"></span>
              </el-button>
              <el-button :class="[{ 'isActive': status === 'draw' }]" type="primary" @click="measureArea">
                <span class="iconfont icon-icon_map_dianziweilan global-icon"></span>
              </el-button>
              <!-- <el-button v-if="status !== 'delete'" type="primary" @click="clearSelectPolygon">
                <img src="@/assets/icon/irrigation/icon_map_shanchu.svg">
              </el-button>
              <el-button v-else :class="[{ 'isActive': status === 'delete' }]" type="primary"
                @click="clearSelectPolygon">
                <img src="@/assets/icon/irrigation/icon_map_shanchu1.svg">
              </el-button> -->
            </el-button-group>
          </div>
          <div id="container" class="container"></div>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import { twoDecimalNoZero } from '@/utils/validate'
import { getPolygons } from '@/utils/util'
// import vjmap from 'vjmap'
// import 'vjmap/dist/vjmap.min.css'
import { vjEnv } from '@/utils/config'

export default {
  data () {
    return {
      status: '',
      mouseTool: null,
      overlays: [],
      info: {
        areaName: '',
        areaExtent: '',
        projectId: '',
        locationList: [],
        valveList: '', // 电磁阀列表
        soilList: '', // 土壤列表
        waterList: '', // 水电列表
        electricityList: '', // 电表列表
        waterLyList: '' // 流速
      },

      max9Length: (rule, value, callback) => {
        if (value && value.split('.')[0] && value.split('.')[0].length > 9) {
          callback(new Error('请输入9位以内的数!'))
        } else {
          callback()
        }
      },
      // 土壤温湿
      onlineWenImg: require('@/assets/icon/soilHumidity/normal.svg'),
      onlineWenImgCursor: require('@/assets/icon/soilHumidity/normal-big.svg'),
      offWenImg: require('@/assets/icon/soilHumidity/offline.svg'),
      offImgWenCursor: require('@/assets/icon/soilHumidity/offline-big.svg'),
      alarmWenImg: require('@/assets/icon/soilHumidity/warning.svg'),
      alarmWenImgCursor: require('@/assets/icon/soilHumidity/warning-big.svg'),
      // 喷灌
      onlinePenImg: require('@/assets/icon/irrigation/icon_map_penguan_zaixian.svg'),
      offPenImg: require('@/assets/icon/irrigation/icon_map_penguan_lixian.svg'),
      onlinePenImgCursor: require('@/assets/icon/irrigation/icon_map_penguan_zaixian1.svg'),
      offPenImgCursor: require('@/assets/icon/irrigation/icon_map_penguan_lixian1.svg'),
      // 电
      onlineDianImg: require('@/assets/icon/irrigation/icon_map_dian_zaixian.svg'),
      offDianImg: require('@/assets/icon/irrigation/icon_map_dian_lixian.svg'),
      onlineDianImgCursor: require('@/assets/icon/irrigation/icon_map_dian_zaixian1.svg'),
      offDianImgCursor: require('@/assets/icon/irrigation/icon_map_dian_lixian1.svg'),
      // 水表
      onlineWaterImg: require('@/assets/icon/irrigation/icon_map_water_zaixian.svg'),
      onlineWaterImgCursor: require('@/assets/icon/irrigation/icon_map_water_zaixian1.svg'),
      offWaterImg: require('@/assets/icon/irrigation/icon_map_water_lixian.svg'),
      offWaterImgCursor: require('@/assets/icon/irrigation/icon_map_water_lixian1.svg'),


      // 流压监测
      onlineLyImg: require('@/assets/icon/water/normal.svg'),
      onlineLyImgCursor: require('@/assets/icon/water/normal-big.svg'),
      offLyImg: require('@/assets/icon/water/offline.svg'),
      offImgLyCursor: require('@/assets/icon/water/offline-big.svg'),
      alarmLyImg: require('@/assets/icon/water/warning.svg'),
      alarmLyImgCursor: require('@/assets/icon/water/warning-big.svg'),

      rules: {
        areaName: [{ required: true, message: '请输入区域名称', trigger: ['change'] }],
        areaExtent: [{ validator: twoDecimalNoZero, trigger: ['blur', 'change'] }, { validator: this.max9Length, trigger: ['blur', 'change'] }],
        valveList: [{ required: true, message: '请选择电磁阀', trigger: ['blur'] }]
      },

      // 电磁阀
      valveList: [],
      soilList: [],
      waterList: [],
      electricityList: [],
      waterLyList: [],
      map: null,
      submitShow: false,
      ploygons: [],
      selectPolygon: { ind: -1, polygon: null },
      polygonSelectStyle: {
        strokeColor: '#FF402B',
        fillColor: '#FF402B',
        strokeWeight: 4,
        strokeOpacity: 1,
        fillOpacity: 0.5,
        strokeStyle: 'solid'
      },

      polygonCurrentStyle: {
        strokeColor: '#9D4DFF',
        fillColor: '#9D4DFF',
        strokeWeight: 4,
        strokeOpacity: 1,
        fillOpacity: 0.5,
        strokeStyle: 'solid',
        cursor: 'pointer',
        zIndex: 1000
      },

      polygonStyle: {
        strokeColor: '#3592FE',
        fillColor: '#3592FE',
        strokeWeight: 4,
        strokeOpacity: 1,
        fillOpacity: 0.3,
        strokeStyle: 'solid',
        zIndex: 100
      }

    }
  },
  computed: {
    areaId () {
      return this.$route.params.id
    },
    projectId () {
      return this.$route.query.projectId
    },
    mapCenter () {
      const project = this.projectInfo
      return [+project.longitude || 118.7587, +project.latitude || 31.9686]
    },
    projectInfo () {
      return this.$store.state.projectList.find(item => item.projectId === this.projectId) || {}
    },
    cadEpsg () {
      return this.projectInfo.epsg
    },
    isCad () {
      return !!this.projectInfo.cadId
    }
  },

  created () {
    this.popup = null
    this._markers = []
    this.info.projectId = this.projectId
  },
  async mounted () {
    try {
      await this.initMap()
    } catch (error) {
    }
    if (!this.isCad) {
      this.loadProjectFence()
    }
    Promise.all([
      this.selectIrrigationValveByList(),
      this.selectIrrigationSoilByList(),
      this.selectIrrigationWaterByList(),
      this.selectIrrigationwaterLyListByList(),
      this.selectIrrigationElectricityByList()
    ]).then(() => {
      if (this.areaId) {
        this.loadDetail().then(() => {
          this.drawMarkers()
        })
      }
    })
  },
  beforeDestroy () {
    this.clearMarkers()
    this._map && this._map.remove()
  },
  methods: {
    getBindName (item) {
      return item.areaId ? item.deviceNumber + '(已绑定)' : item.deviceNumber
    },

    // 喷灌电磁阀
    selectIrrigationValveByList () {
      return this.$axios.get(this.$apis.irrigation.selectJgIrrigationValve, {
        ...this.getParams(),
        projectId: this.projectId
      }).then((res) => {
        this.valveList = res || []
      })
    },

    // 喷灌土壤设备
    selectIrrigationSoilByList () {
      return this.$axios.get(this.$apis.irrigation.selectJgIrrigationSoilByList, {
        ...this.getParams(),
        projectId: this.projectId
      }).then((res) => {
        this.soilList = res || []
      })
    },

    // 喷灌水表设备
    selectIrrigationWaterByList () {
      return this.$axios.get(this.$apis.irrigation.selectJgIrrigationWaterByList, {
        ...this.getParams(),
        projectId: this.projectId
      }).then((res) => {
        this.waterList = res || []
      })
    },

    // 查询喷灌电表设备列表
    selectIrrigationElectricityByList () {
      return this.$axios.get(this.$apis.irrigation.selectJgIrrigationElectricityByList, {
        ...this.getParams(),
        projectId: this.projectId
      }).then((res) => {
        this.electricityList = res || []
      })
    },

    // 查询流压设备列表
    selectIrrigationwaterLyListByList () {
      return this.$axios.get(this.$apis.irrigation.selectJgIrrigationWaterLyByList, {
        ...this.getParams(),
        projectId: this.projectId
      }).then((res) => {
        this.waterLyList = res || []
      })
    },

    getParams () {
      return {
        areaId: this.areaId,
        isCad: this.isCad ? '1' : '0'
      }
      // return this.areaId ? {} : {}
    },

    // 获取电子围栏
    loadProjectFence () {
      this.$axios.get(this.$apis.project.selectYhProjectMapByProjectId, {
        projectId: this.projectId
      }).then(async (res) => {
        if (res.locationList && res.locationList.length) {
          const polygons = getPolygons(res.locationList)
          polygons.forEach(item => {
            this.addMarkersToPolygon(item[1], item[0], {
              fillColor: '#36cbcb',
              fillOutlineColor: '#36cbcb',
              fillOpacity: 0.5
            })
          })
        }
      })
    },
    cadToWebCoordinate (point) {
      const cadEpsg = this.cadEpsg || 'EPSG:4549' // cad图的espg代号
      const co = proj4(cadEpsg, 'EPSG:4326', point)
      // 把wgs84转成高德坐标坐标
      return vjmap.transform.convert(co, vjmap.transform.CRSTypes.WGS84, vjmap.transform.CRSTypes.GCJ02)
    },
    markerAdd (item, index) {
      item.type = index
      const el = document.createElement('div')
      el.className = 'marker'
      el.style.backgroundImage = `url('${index === 3 ? this.getIconPen(item, false) : this.getIcon(item, false)}')`
      el.style.width = !item.deviceNumber ? '48px' : '36px'
      el.style.height = '48px'
      el.style.backgroundSize = '100%'
      // 有cad图层未绑定设备cad转经纬度
      // if (!item.deviceNumber) {
      // }
      if (this.isCad) {
        const cadPoints = vjmap.geoPoint([item.objectX, item.objectY])
        const lngLat = this.cadToWebCoordinate(cadPoints)
        item.longitude = lngLat[0]
        item.latitude = lngLat[1]
      }
      const co = [item.longitude, item.latitude]
      const marker = new vjmap.Marker({
        element: el,
        anchor: 'bottom'
      })
      console.log('index', index)
      console.log('co', co)
      marker.setLngLat(co).addTo(this._map)
      el.addEventListener('click', () => {
        // this.drawerOpen(item)
      })
      this._markers.push(marker)
    },
    // 处理图标状态 bigShow:是否大图标
    getIcon (data, bigShow) {
      let icon
      if (data.type === 0) {
        if (data.deviceStatus === '1') {
          icon = data.runStatus === '1' ? (bigShow ? this.alarmWenImgCursor : this.alarmWenImg) : (bigShow ? this.onlineWenImgCursor : this.onlineWenImg)
        } else if (data.deviceStatus === '2') {
          icon = bigShow ? this.offImgWenCursor : this.offWenImg
        }
        return icon
      } else if (data.type === 2) {
        if (data.deviceStatus === '1') {
          icon = bigShow ? this.onlineDianImg : this.onlineDianImgCursor
        } else if (data.deviceStatus === '2') {
          icon = bigShow ? this.offDianImg : this.offDianImgCursor
        }
      } else if (data.type === 1) {
        if (data.deviceStatus === '1') {
          icon = bigShow ? this.onlineWaterImg : this.onlineWaterImgCursor
        } else if (data.deviceStatus === '2') {
          icon = bigShow ? this.offWaterImg : this.offWaterImgCursor
        }
      } else if (data.type === 4) {
        if (data.deviceStatus === '1') {
          icon = data.pressureStatus === '1' || data.pressureStatus === '2'  ? (bigShow ? this.alarmLyImgCursor : this.alarmLyImg) : (bigShow ? this.onlineLyImgCursor : this.onlineLyImg)
        } else if (data.deviceStatus === '2') {
          icon = bigShow ? this.offImgLyCursor : this.offLyImg
        }
        return icon
      }
      return icon
    },

    // 处理图标状态 bigShow:是否大图标 开启关闭
    getIconPen (data, bigShow) {
      let icon
      // 在线
      if (data.switchStatus === '1') {
        icon = bigShow ? this.onlinePenImgCursor : this.onlinePenImg
      } else if (data.switchStatus === '0') {
        // 离线
        icon = bigShow ? this.offPenImgCursor : this.offPenImg
      }
      return icon
    },
    drawMarkers () {
      console.log('执行了画点')
      this.clearMarkers()
      const soilList = this.soilList.filter(item => this.info.soilList.includes(item.deviceNumber))
      soilList.forEach((item) => {
        this.markerAdd(item, 0)
      })
      console.log('soilList', soilList)

      const waterList = this.waterList.filter(item => this.info.waterList.includes(item.deviceNumber))
      waterList.forEach((item) => {
        this.markerAdd(item, 1)
      })
      console.log('waterList', waterList)

      const electricityList = this.electricityList.filter(item => this.info.electricityList.includes(item.deviceNumber))
      electricityList.forEach((item) => {
        this.markerAdd(item, 2)
      })
      console.log('electricityList', electricityList)

      const valveList = this.valveList.filter(item => this.info.valveList.includes(item.deviceNumber))
      valveList.forEach((item) => {
        this.markerAdd(item, 3)
      })
      console.log('valveList', valveList)

      const waterLyList = this.waterLyList.filter(item => this.info.waterLyList.includes(item.deviceNumber))
      waterLyList.forEach((item) => {
        this.markerAdd(item, 4)
      })
      console.log('waterLyList', waterLyList)
    },
    clearMarkers () {
      if (this._markers.length) {
        this._markers.forEach(item => item.remove())
      }
      this._markers = []
    },
    // 区域详情
    loadDetail () {
      return this.$axios.get(this.$apis.irrigation.selectIrrigationAreaByAreaId, {
        areaId: this.areaId
      }).then((res) => {
        this.info = res
        if (res.locationList && res.locationList.length && !this.isCad) {
          const polygons = getPolygons(res.locationList)
          polygons.forEach(item => {
            this.addMarkersToPolygon(item[1], item[0], {
              fillColor: '#3592FE',
              fillOutlineColor: '#3592FE'
            }, true)
          })
        }
      })
    },
    async initMap () {
      // --高德地图(地图数据前端获取)--
      const svc = new vjmap.Service(vjEnv.serviceUrl, vjEnv.accessToken)
      this._svc = svc
      // 根据地图范围建立经纬度投影坐标系
      const prj = new vjmap.LnglatProjection()
      // wgs84坐标
      const coWgs84 = prj.toLngLat(this.mapCenter)
      // 把wgs84转成高德坐标坐标
      const coGCJ02 = vjmap.transform.convert(coWgs84, vjmap.transform.CRSTypes.WGS84, vjmap.transform.CRSTypes.GCJ02)
      // 地图对象
      this._map = new vjmap.Map({
        container: 'container', // DIV容器ID
        style: {
          version: svc.styleVersion(),
          glyphs: svc.glyphsUrl(),
          sources: {
            gaodeRoadSource: {
              type: 'raster',
              tiles: ['https://webrd02.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}']
            },
            // 影像无文字注记
            gaodeImgSource: {
              type: 'raster',
              tiles: [
                'https://webst02.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=6&x={x}&y={y}&z={z}'
              ]
            },
            // 影像文字注记
            gaodeImgSourceLabel: {
              type: 'raster',
              tiles: [
                'https://webst02.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}'
              ]
            }
          },
          layers: [{
            id: 'gaodeRoad',
            type: 'raster',
            source: 'gaodeRoadSource'
          }, {
            id: 'gaodeImg',
            type: 'raster',
            source: 'gaodeImgSource',
            layout: {
              visibility: 'none'
            }
          }, {
            id: 'gaodeImgLabel',
            type: 'raster',
            source: 'gaodeImgSourceLabel',
            layout: {
              visibility: 'none'
            }
          }]
        },
        center: prj.toLngLat(coGCJ02),
        zoom: 15,
        pitch: 0,
        renderWorldCopies: false // 不显示多屏地图
      })

      // 关联服务对象和投影对象
      this._map.attach(svc, prj)
      // 根据地图本身范围缩放地图至全图显示
      await this._map.onLoad()

      // 加载proj4库，用于坐标转换
      if (typeof proj4 !== 'object') {
        // 如果没有环境
        await vjmap.addScript([{
          src: 'https://vjmap.com/demo/js/proj4.min.js'
        }])
      }
      if (this.isCad) {
        const res = await this.openCAD()
        await this.addDefaultLayer(res)
      }
    },
    async addDefaultLayer (res) {
      const cadEpsg = this.cadEpsg
      const wmsUrl = this._svc.wmsTileUrl({
        mapid: this.projectInfo.cadId, // 地图id
        layers: res.layer, // 图层名称
        srs: 'EPSG:3857',
        crs: cadEpsg,
        webMapType: 'GCJ02' // 底图是高德地图，所以要选GCJ02,如果是天地图，可以不用填此项
      })
      this._map.addSource('wms-test-source', {
        type: 'raster',
        tiles: [
          wmsUrl
        ],
        tileSize: 256
      })
      this._map.addLayer({
        id: 'wms-test-layer',
        type: 'raster',
        source: 'wms-test-source',
        paint: { 'raster-opacity': 1 }
      }
      )
      await this.initEpsgProj({
        longitude: this.mapCenter[0],
        latitude: this.mapCenter[1]
      }, this.projectInfo.cadId)
      proj4.defs('EPSG:4326', '+proj=longlat +datum=WGS84 +no_defs +type=crs')
      // proj4.defs(cadEpsg, epsgArr[0].proj)
      // cad图坐标转web wgs84坐标，再转火星坐标（高德)
      const cadToWebCoordinate = point => {
        const co = proj4(cadEpsg, 'EPSG:4326', vjmap.geoPoint(point).toArray())
        // 把wgs84转成高德坐标坐标
        const dataaaa = vjmap.transform.convert(co, vjmap.transform.CRSTypes.WGS84, vjmap.transform.CRSTypes.GCJ02)
        return dataaaa
      }
      // // 火星坐标（高德)转web wgs84坐标转cad图坐标
      // const webTocadCoordinate = point => {
      //   const co = vjmap.transform.convert(point, vjmap.transform.CRSTypes.GCJ02, vjmap.transform.CRSTypes.WGS84)
      //   return proj4('EPSG:4326', cadEpsg, co)
      // }
      // 根据cad图的中心点，计算wgs84的中心点坐标
      const mapBounds = vjmap.GeoBounds.fromString(res.bounds)
      const cadCenter = mapBounds.center()
      // if (String(parseInt(cadCenter.x)).length === 8) {
      //   cadCenter.x = parseFloat(String(cadCenter.x).slice(2))
      // }
      // console.log('cadCenter', cadCenter)
      const webCenter = cadToWebCoordinate(cadCenter)
      // 把cad图的中点设置为地图的中心点
      console.log('webCenter', webCenter)
      this._map.setCenter(webCenter)
    },
    async openCAD (mapid, fileid) {
      const mapId = mapid || this.projectInfo.cadId
      console.log('mapId', mapId)
      console.log('fileid', fileid)
      this._svc.switchWorkspace(vjEnv.workspace)
      const res = await this._svc.openMap({
        fileid: fileid,
        mapid: mapId, // 地图ID,(请确保此ID已存在，可上传新图形新建ID)
        // mapopenway: vjmap.MapOpenWay.GeomRender, // 以几何数据渲染方式打开
        mapopenway: vjmap.MapOpenWay.Memory,
        style: vjmap.openMapDarkStyle() // div为深色背景颜色时，这里也传深色背景样式
      })
      return res
    },
    setPopupText (text) {
      if (text) {
        if (!this.popup) {
          this.popup = new vjmap.Popup({
            className: 'custom-popup',
            closeOnClick: false,
            closeButton: false
          })
            .setHTML(text)
            .setMaxWidth('500px')
            .trackPointer()
            .addTo(this._map)
        } else {
          this.popup.setHTML(text)
        }
      } else {
        // 如果为空时，则删除popup
        if (this.popup) {
          this.popup.setLngLat([0, 0]) // 取消trackPointer
          this.popup.remove()
          this.popup = null
        }
      }
    },
    async initEpsgProj ({ longitude, latitude }, mapId) {
      const metadata = await this._svc.metadata(mapId, 'v1')
      const x = longitude
      const y = latitude
      const cadX = String(parseInt(metadata.initCenterX))
      let res = []
      if (cadX.length === 8) {
        const proj = vjmap.transform.getEpsgParam(vjmap.transform.EpsgCrsTypes.CGCS2000, parseInt(cadX.slice(0, 2)))
        res.push(proj)
      } else {
        res = vjmap.transform.getEpsgCode([x, y], vjmap.transform.EpsgCrsTypes.CGCS2000, '')
      }
      console.log('pro4', res)
      for (const item of res) {
        if (item.proj) {
          proj4.defs(item.epsg, item.proj)
        }
        if (x < 180) {
          // 经纬度转 cad投影坐标
          item.convertCoordinate = proj4('EPSG:4326', item.epsg, [x, y])
        } else {
          // cad投影坐标转经纬度
          item.convertCoordinate = proj4(item.epsg, 'EPSG:4326', [x, y])
        }
      }
      console.log('最终的pro', res)
      return res
    },
    async getMapEpsg ({ longitude, latitude }, mapId) {
      const res = await this.initEpsgProj({ longitude, latitude }, mapId)
      const metadata = await this._svc.metadata(mapId, 'v1')
      const point1 = {
        x: parseFloat(metadata.initCenterX),
        y: parseFloat(metadata.initCenterY)
      }
      if (String(parseInt(point1.x)).length === 8) {
        point1.x = parseFloat(String(point1.x).slice(2))
      }
      for (const i of res) {
        const distance = this.calculateDistance(point1, {
          x: i.convertCoordinate[0],
          y: i.convertCoordinate[1]
        })
        i.distance = distance
      }
      const newEpsgArr = res.sort((a, b) => {
        return a.distance - b.distance
      })
      const cadEpsg = newEpsgArr[0].epsg
      console.log('cadEpsg', cadEpsg)
      return cadEpsg
      // setEpsgText(JSON.stringify(res, null, 4))
    },
    // 测量面积
    sleep (tm) {
      return new Promise(resolve => setTimeout(resolve, tm))
    },
    async measureArea () {
      this.status = 'draw'
      let isDrawing = false
      await this.sleep(500) // 防止双击结束时误多点了几个点被当前下一次的起点了
      const poly = await vjmap.Draw.actionDrawPolygon(this._map, {
        api: {
          getSnapFeatures: {} // 要捕捉的数据项在后面，通过属性features赋值
        },
        updatecoordinate: (e) => {
          if (!e.lnglat) return
          isDrawing = true
          const co = this._map.fromLngLat(e.feature.coordinates[0][e.feature.coordinates.length - 1])
          let html = `当前坐标:<span style="color: #ff0000"> ${co.x.toFixed(2)}, ${co.y.toFixed(2)}</span>`
          if (e.feature.coordinates[0].length === 1) {
            html += '<br/>请指定要测量的第一点的坐标位置'
          } else {
            html += '<br/>按Alt键取捕捉; Ctrl键启用正交; 退格键删除上一个点'
          }
          this.setPopupText(html)
        },
        contextMenu: (e) => {
          const ss = new vjmap.ContextMenu({
            event: e.event.originalEvent,
            theme: 'dark', // light
            width: '250px',
            items: [
              {
                label: '确认',
                onClick: () => {
                  // 给地图发送Enter键消息即可取消，模拟按Enter键
                  this._map.fire('keyup', { keyCode: 13 })
                  this.setPopupText('')
                }
              },
              {
                label: '取消',
                onClick: () => {
                  // 给地图发送ESC键消息即可取消，模拟按ESC键
                  this._map.fire('keyup', { keyCode: 27 })
                  this.setPopupText('')
                }
              }, {
                label: '删除上一个点',
                onClick: () => {
                  // 给地图发送退格键Backspace消息即可删除上一个点，模拟按Backspace键
                  this._map.fire('keyup', { keyCode: 8 })
                }
              }, {
                label: '结束测面积',
                onClick: () => {
                  // 给地图发送ESC键消息即可取消，模拟按ESC键
                  this._map.fire('keyup', { keyCode: 27 })
                  isDrawing = false
                  this.setPopupText('')
                }
              }
            ]
          })
          console.log('ss', ss)
        }
      })
      if (poly.cancel) {
        this.setPopupText('')
        return {
          cancel: true,
          exit: isDrawing === false // 如果还没有绘制，就取消的话，就结束测距
        }// 取消操作
      }
      const coordinates = poly.features[0].geometry.coordinates[0]
      const fenceCode = Date.now()
      this.info.locationList = this.info.locationList.concat(coordinates.map(item => {
        return { longitude: item[0], latitude: item[1], fenceCode: fenceCode }
      }))
      this.addMarkersToPolygon(coordinates, fenceCode, {
        fillColor: '#3592FE',
        fillOutlineColor: '#3592FE'
      }, true)
    },
    // 给加个测量的结果值
    addMarkersToPolygon (coordinates, fenceCode, style, status = false) {
      const polygon = new vjmap.Polygon({
        data: coordinates,
        fillColor: style.fillColor,
        fillOpacity: style.fillOpacity || 0.8,
        fillOutlineColor: style.fillOutlineColor
      })
      polygon.addTo(this._map)
      console.log('polygon', polygon.sourceId)
      if (!status) {
        return
      }
      let markerTexts = []
      // 给第一个点加一个marker用来删除
      const deletePng = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAbNJREFUWEftlrFOAkEQhv9Z4XgJOCrlTgp5ABOhMBoTCws7EzUaeAx5A0sDiYmFxpLGaAkU2KqFArHi4CU4cMccAQN6HHcIwZi7cnd25tt/5maHsOCPFhwfPoAnBarhQFIIccjAkV3qCMhKKct6q1tym1pPAHVVOWMg6+ScgKuYYR7PBaCmKmw5XgLiy4b5NhzkXVVWP4BXa00zTNcXc21oOR4AjAswaX9M2n4u1yLBIoiSbmV0Zcdc0pqd1HdbWwUWDuDqRjMy8lQDM4o54sYRoJcKq6qHclePKnuScQ0pd/RWt2ztVyOhLUFckIwTvWneDiLYnXdVA18O+r/dcNXXIsozCGsMzuhGJ98DUINpAuUAqmhGe33k/JjiG9g4K2ADUFdDOQan7QAIlI8Z7YwP4CvgK/C/FahFlQcwtm0bEeNFa5qJuSpgdT2AzkFyU290H3udMBzYgBD3gnAQa5iFuQJ4eZB6A8ovW/ETgARLmfIyaPZVSZIQRTBdas326Thwx7fAzRA6SREB2l0x2ndTAfTnwH0CrGk4PinY6D5VQHyhNcwbp3N/eyDxduPprH0FPgHEyH4wGIHUYwAAAABJRU5ErkJggg=='
      const el = document.createElement('div')
      el.className = 'marker'
      el.style.backgroundImage =
        `url(${deletePng})`
      el.style.width = '20px'
      el.style.height = '20px'
      el.style.backgroundSize = '100%'
      el.style.cursor = 'pointer'

      el.addEventListener('click', (e) => {
        this._map.removeSourceEx(polygon.sourceId) // 删除绘制的线
        markerTexts.forEach(m => m.remove())
        markerTexts = []
        this.info.locationList = this.info.locationList.filter(item => item.fenceCode !== fenceCode)
      })
      // Add markers to the map.
      const deleteMarker = new vjmap.Marker({
        element: el,
        anchor: 'right'
      })
      deleteMarker.setLngLat(coordinates[0])
        .setOffset([-5, 0])
        .addTo(this._map)
      markerTexts.push(deleteMarker)

      this._map.fire('keyup', { keyCode: 27 })
      this.setPopupText('')

      // 把坐标加进捕捉数组中。
      // addSnapCoordinates(coordinates);
    },
    // 选中
    choosePolyon () {
      this.status = 'choose'
      this._map.fire('keyup', { keyCode: 27 })
      this.setPopupText('')
      // this.mouseTool.close()
      // this.overlays.forEach(item => {
      //   item.on('click', this.polygonClick)
      // })
    },
    onSubmit () {
      this.$refs.info.validate((valid) => {
        if (valid) {
          this.submitShow = true
          const url = this.areaId ? this.$apis.irrigation.updateIrrigationArea : this.$apis.irrigation.insertIrrigationArea
          this.$axios.post(url, {
            ...this.info
          }).then(() => {
            this.$message({ message: '保存成功', type: 'success' })
            this.$router.back()
          }).catch((err) => {
            this.submitShow = false
            this.$message(err)
          })
        }
      })
    }
  }

}
</script>

<style scoped lang="scss">
@import "@/assets/scss/color";

.penguan-content {
  display: flex;

  .left {
    width: 600px;
    margin-right: 15px;
  }

  .right {
    flex: 1;
  }
}

#container {
  max-width: 100%;
  width: 100%;
  height: 500px;
  overflow: hidden;
  margin: 0;
}

.map {
  position: relative;
  width: 100%;

  .rangeMapOperation {
    position: absolute;
    top: 20px;
    left: 20px;
    z-index: 99999;

    .el-button-group {
      border: 1px solid $color-default;
      border-radius: 3px;

      .el-button {
        width: 64px;
        height: 46px;
        background-color: #fff;

        .global-icon {
          font-size: 28px;
          color: $color-default;
        }

        &.isActive {
          background-color: $color-default;

          .global-icon {
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
